var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-form-select',{staticStyle:{"border":"1px solid gray","color":"black"},attrs:{"options":_vm.listTickerOptionsNoLegSwapping,"size":"sm"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }